import { useNotification } from "./NotificationContainer";
import * as s from "./NotificationStyle";
import { ReactComponent as IconNotification } from "assets/icons/bell.svg";

export default function NotificationButton() {
  const { isOpen, toggleOpen, accountLevel, count } = useNotification();
  return (
    <s.NotificationButton
      onClick={(e) => {
        e.stopPropagation();
        toggleOpen();
      }}
      data-testid="blocks-headernav-notification-button-toggle-open"
      accountLevel={accountLevel}
    >
      <s.IconNotification open={isOpen}>
        <IconNotification />
      </s.IconNotification>
      {count > 0 && <span>{count > 9 ? "9+" : count}</span>}
    </s.NotificationButton>
  );
}
